(function () {
  const cardLinks = document.querySelectorAll('.js-card-link');
  const focusedClass = 'curated-cards__card--link-focus';

  [...cardLinks].forEach((link) => {
    const card = link.closest('.js-card');
    if (card) {
      link.addEventListener('focus', () => {
        card.classList.add(focusedClass);
      });
      link.addEventListener('blur', () => {
        card.classList.remove(focusedClass);
      });
    }
  });
})();
